import audreybreakfastprint from "../../../image/originals/hollywoodicons/audreybreakfastprint.webp"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "89_base",
      name: "Audrey Hepburn (Breakfast at Tiffanys) Print",
      image: audreybreakfastprint, // Main image without .webp
      price: "empty for now",
      thumbnails: [audreybreakfastprint], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/AudreyHepburn(BreakfastatTiffanys)Print",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
